import { useFormikContext } from "formik";
import { OrDropdown } from "../shared_modules/ui/components/atoms/or-dropdown/or-dropdown";
import { usePositions } from "./usePositions";

export function PositionSelect({ value, errors, touched, theme }) {
  const [positions] = usePositions();
  const { setFieldValue } = useFormikContext();

  let view = "";

  if (positions) {
    view = (
      <div className="or-auth-form__group">
        <OrDropdown
          disableClearable={true}
          errorText={touched.position ? errors.position : ""}
          getOptionLabel={(option) => {
            const selectedPosition = positions.find((position) => position.id === option.id);
            return selectedPosition ? selectedPosition.name : "";
          }}
          hasError={touched.position && Boolean(errors.position)}
          isOptionEqualToValue={(option, selectedValue) => {
            if (!selectedValue) {
              return false;
            }

            const selectedId = typeof selectedValue === "string" ? selectedValue : selectedValue && selectedValue.id;
            return option.id === selectedId;
          }}
          label="Puesto/Cargo *"
          name="position"
          onChange={(_event, nextValue) => {
            if (nextValue) {
              setFieldValue("position", nextValue);
            }
          }}
          options={positions}
          theme={theme}
          value={value}
        />
      </div>
    );
  }

  return view;
}
